export const API_URL =
  "https://dulbeu64sc.execute-api.us-east-1.amazonaws.com/v1";
